import PropTypes from "prop-types";
import React from "react";

import { createClassNameString } from "../utils";
import { getAutomationDataAttr } from "../../utils/automationUtils";
import { testLocator } from "../../lib/helpers/test-locator";

import "./styles.scss";

export const TextArea = ({
  children,
  className,
  error,
  ignoreEnterSubmit,
  name,
  placeholder,
  resize,
  testId,
  ...props
}) => {
  let getPointer = (el) => {
    if (el.selectionStart) {
      return el.selectionStart;
    }

    return 0;
  };

  let onKeyDown = (e) => {
    if (e.key === "Enter" && ignoreEnterSubmit) {
      let content = e.target.value;
      let pointerPosition = getPointer(e.target);

      e.target.value =
        content.substring(0, pointerPosition) + content.substring(pointerPosition, content.length);
      e.stopPropagation();
    }
  };

  return (
    <textarea
      className={createClassNameString([
        "apti-CL apti-TextArea",
        className,
        `resize-${resize}`,
        error && "error",
      ])}
      name={name}
      onKeyDown={onKeyDown}
      placeholder={placeholder}
      {...getAutomationDataAttr(testId)}
      {...testLocator(testId)}
      {...props}
    >
      {children}
    </textarea>
  );
};

TextArea.propTypes = {
  children: PropTypes.string,
  className: PropTypes.string,
  error: PropTypes.bool,
  ignoreEnterSubmit: PropTypes.bool,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  resize: PropTypes.oneOf(["both", "horizontal", "vertical", "none"]),
  testId: PropTypes.string,
};

TextArea.defaultProps = {
  children: undefined,
  className: undefined,
  error: false,
  ignoreEnterSubmit: false,
  name: "",
  placeholder: undefined,
  resize: "none",
  testId: undefined,
};
